import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { AppMaterialModule } from '../shared/app-material.module';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { WeatherComponent } from './components/weather/weather.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { SecurityComponent } from './components/security/security.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { MfaComponent } from './components/mfa/mfa.component';
import { DownloadHandbookComponent } from './components/download-handbook/download-handbook.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SidenavComponent,
    HeaderComponent,
    LoginComponent,
    RegisterComponent,
    WeatherComponent,
    SettingsComponent,
    SecurityComponent,
    NotificationsComponent,
    ContactUsComponent,
    MfaComponent,
    DownloadHandbookComponent,
  ],
  imports: [
    AppMaterialModule,
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  exports: [
    SidenavComponent,
    HeaderComponent,
    LoginComponent,
    RegisterComponent,
    WeatherComponent,
    SettingsComponent,
    SecurityComponent,
    NotificationsComponent,
    ContactUsComponent,
    MfaComponent,
    DownloadHandbookComponent,
  ],
})
export class SidenavModule {}
